import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-269c45cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 2,
  class: "pl-xs"
}

import UButton from "./UButton.vue";
import { computed, ref } from "vue";
import { getIcon, Icon } from "@/assets/icons/icons";
import LoadingSpinner from "./LoadingSpinner.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'IconButton',
  props: {
    icon: {},
    label: {},
    onClick: {},
    onClickArgs: {},
    color: {},
    position: {}
  },
  emits: ["click"],
  setup(__props: any) {



const icon = computed(() => getIcon(props.icon));
const loading = ref<boolean>(false);

const props = __props;

async function clicked() {
  if (!props.onClick || typeof props.onClick !== "function") return;
  loading.value = true;
  try {
    if (props.onClickArgs && props.onClickArgs.length) {
      await props.onClick(...props.onClickArgs);
    } else {
      await props.onClick();
    }
  } finally {
    loading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UButton, {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (clicked())),
    disabled: loading.value,
    square: _ctx.label ? false : true,
    color: _ctx.color ?? 'white',
    position: props.position,
    "dont-load": true
  }, {
    default: _withCtx(() => [
      (!loading.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: icon.value,
            class: _normalizeClass(["w-ms", { invert: (_ctx.color ?? 'white') != 'white' }])
          }, null, 10, _hoisted_1))
        : (_openBlock(), _createBlock(LoadingSpinner, {
            key: 1,
            class: "w-ms"
          })),
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.label), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["disabled", "square", "color", "position"]))
}
}

})